














import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { GETTER_CURRENT_USER_ID } from "@/store/constants/index_types";
import { GETTER_CURRENT_INS_USER_INFO } from "@/store/constants/ins_user_info_types";
import ExceptionPost from "./ExceptionPost.vue";
import SelectPost from "./SelectPost/SelectPost.vue";
import EmptyAccount from "./EmptyAccount.vue";
import { GETTER_CURRENT_USER_MEDIA_LIST } from "@/store/constants/ins_media_types";
import Loading from "@/components/Loading/Loading.vue";
@Component({
  components: {
    ExceptionPost,
    SelectPost,
    EmptyAccount,
    Loading
  }
})
export default class PostInfo extends Vue {
  @Getter(GETTER_CURRENT_USER_MEDIA_LIST)
  private currentMediaList: any;
  @Getter(GETTER_CURRENT_USER_ID)
  private currentUserId: any;
  @Getter(GETTER_CURRENT_INS_USER_INFO)
  private currentInsUserInfo: any;

  get showPrivatePost() {
    // 搜索账号，并且是私有账号
    return (
      this.currentInsUserInfo &&
      this.currentInsUserInfo.user_type === "search" &&
      this.currentInsUserInfo.ins_user_info &&
      this.currentInsUserInfo.ins_user_info.is_private
    );
  }

  get showEmptyPost() {
    //
    if (this.currentMediaList) {
      const { fetched, ins_media_list } = this.currentMediaList;
      if (fetched === true && ins_media_list.length === 0) {
        // 已经拉取过，并且长度为0
        return true;
      }
    }
    return false;
  }

  get showEmptyAccount() {
    return !this.currentUserId;
  }

  get showPullingPost() {
    // fetch_status为fetching，并且没有fetched过:
    if (this.currentMediaList) {
      const { fetch_status, fetched } = this.currentMediaList;
      if (fetch_status === "fetching" && fetched === false) {
        return true;
      }
    }
    return false;
  }
}
